import "./views-autosubmit-fix";
import "./webp-fallback/webp-fallback";
import "./link-noreferrer-fix";
import "./link-blank-add-icon-open-in-new";
import "./form-required-mention";
import "./fit-text-utils";
import "./a11y-misc";
import "./lazyload-video";
// Signature SSKS
console.log(
  "%c✈️ Supersoniks",
  "color:white;padding:5px;background:black;font-size:12px;border-radius:3px;"
);
